import { render, staticRenderFns } from "./RemoveBatteries.vue?vue&type=template&id=64062cad&lang=pug&"
import script from "./RemoveBatteries.vue?vue&type=script&lang=js&"
export * from "./RemoveBatteries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports